module.exports = __webpack_public_path__ + "img/fig15.30496fe6.jpg";